export default class  CalendarItem {
  constructor(private readonly _id: string,
              private readonly _title: string,
              private readonly _date: Date,
              private readonly _categories: string[]) {

  }

  get id(): string {
    return this._id;
  }

  get title(): string {
    return this._title;
  }

  get date(): Date {
    return this._date;
  }

  get categories(): string[] {
    return this._categories;
  }
}
